"use strict";var e=require("@apollo/client").gql`
  query GetOperationalModelByClient($clientId: String!) {
    getOperationalModelByClient(clientId: $clientId) {
      operationalModels
    }
  }
`;exports.g=e;